<section [formGroup]="stepForm">
  <mbs-form-group
    *ngIf="isVirtual || (isRestoreHyperV && !importVirtualMachine)"
    [attr.data-e2e]="elementsSelector.name.notVirtualOrHyperVBlock">
    <mbs-destination-folder-input
      [buttonId]="'destination-vm-step-destination-folder-tree'"
      [control]="destinationFolderControl"
      [destinationFolderParams]="destinationFolderParams"
      [disabledSelf]="destinationFolderControl.disabled"
      [hasTargetComputer]="!!mainService?.targetComputerData"
      [inputId]="'destination-vm-step-destination-folder'"
      [isUnix]="isUnix"
      [name]="'destination-vm-step-destinationFolder'"
      [placeholder]="destinationFolderParams?.dataForPath?.isUnix ? '/home' : 'C:\\Folder Name'"></mbs-destination-folder-input>
  </mbs-form-group>

  <div
    *ngIf="notVirtualAndHyperV && importVirtualMachine"
    [attr.data-e2e]="elementsSelector.name.notVirtualHyperVAndImportBlock">
    <h5 class="mb-2">{{ 'wizards:destinationOld.destFolderLabel' | i18next: { format: 'title' } }}</h5>
    <mbs-form-group>
      <mbs-radio
        formControlName="toOriginalLocation"
        name="toOriginalLocation"
        [descriptionOutside]="false"
        [id]="'to-original-location-radio-1'"
        [label]="'wizards:destinationOld.dest_specific_location_label' | i18next"
        [value]="false"
        (change)="powerOnVMChangeHandler($event)">
        <ng-template radioDescription>
          <mbs-destination-folder-input
            [buttonId]="'destination-vm-step-import-destination-folder-tree'"
            [control]="destinationFolderControl"
            [destinationFolderParams]="destinationFolderParams"
            [disabledSelf]="destinationFolderControl.disabled"
            [hasTargetComputer]="!!mainService?.targetComputerData"
            [inputId]="'destination-vm-step-import-destination-folder'"
            [isUnix]="isUnix"
            [label]="''"
            [name]="'destination-vm-step-import-destinationFolder'"
            [placeholder]="destinationFolderParams?.dataForPath?.isUnix ? '/home' : 'C:\\Folder Name'"></mbs-destination-folder-input>
        </ng-template>
      </mbs-radio>
    </mbs-form-group>

    <mbs-form-group>
      <mbs-radio
        formControlName="toOriginalLocation"
        name="toOriginalLocation"
        [id]="'to-original-location-radio-2'"
        [label]="'wizards:destinationOld.destOriginalLocationLabel' | i18next"
        [value]="true"
        (change)="powerOnVMChangeHandler($event)"></mbs-radio>
    </mbs-form-group>
  </div>

  <mbs-form-group
    *ngIf="notVirtualAndHyperV && !importVirtualMachine"
    [attr.data-e2e]="elementsSelector.name.notVirtualAndHyperVOrShowBlock">
    <mbs-switcher
      formControlName="overwriteExistingVM"
      [boldLabel]="false"
      [id]="'overwrite-existing-vm-switcher'"
      [label]="'wizards:destinationOld.destOverwriteVMLabel' | i18next"></mbs-switcher>
  </mbs-form-group>

  <mbs-form-group *ngIf="isRestoreVMWareToVSphere || isRestoreProxmox">
    <h5 class="mb-2">{{ 'wizards:datastoreTitle' | i18next: { format: 'title' } }}</h5>
    <mbs-select
      formControlName="dataStore"
      [appendTo]="'.modal-content'"
      [boldLabel]="false"
      [clearable]="false"
      [hideSelected]="false"
      [id]="'restoreOptionsDataStore'"
      [items]="dataStoreList"
      [label]="'wizards:restoreOptionsDatastoreLabel' | i18next"
      [loading]="dataStoreLoading"
      [searchable]="false"
      [showRequiredMark]="false"></mbs-select>
  </mbs-form-group>

  <mbs-form-group *ngIf="(notVirtualAndHyperV && importVirtualMachine) || isRestoreVMWareToVSphere || isRestoreProxmox">
    <h5 class="mb-2">{{ 'wizards:additionalSettingsTitle' | i18next: { format: 'title' } }}</h5>
    <mbs-switcher
      formControlName="powerOnVM"
      [boldLabel]="false"
      [id]="'power-on-vm-checkbox'"
      [label]="(isRestoreHyperV ? 'wizards:powerOnHVVMLabel' : 'wizards:powerOnVMLabel') | i18next"></mbs-switcher>
  </mbs-form-group>

  <mbs-destination-table
    *ngIf="needTableShow"
    [attr.data-e2e]="elementsSelector.name.tableGrid"
    [dataForItems]="itemsData"
    [forceValidate]="forceValidate"
    [isVirtual]="isVirtual"
    [loadingTableData]="loadingTableData"
    [ngModelOptions]="{ standalone: true }"
    [planType]="planType"
    [showState]="needTableShow"
    [(ngModel)]="overwriteAndSpecific"
    (ngModelChange)="overwriteAndSpecificChangeHandler($event)"></mbs-destination-table>
</section>
